export const APP_NAME = 'Convert Playlist';

export const PLATFORMS = {
  apple: 'apple',
  spotify: 'spotify',
  youtube: 'youtube',
};

export const PLATFORM_CAPTIONS = {
  spotify: 'Spotify',
  youtube: 'YouTube',
  apple: 'Apple Music',
};

export const PLATFORM_COLORS = {
  [PLATFORMS.apple]: '#FA2D48',
  [PLATFORMS.spotify]: '#1ED760',
  [PLATFORMS.youtube]: '#FF0033',
};

export const ACCENT_COLOR = '#E84D1C';

export const CONVERSION = {
  single: 'single',
  profile: 'profile',
  account: 'account',
  accountSel: 'accountSel',
  profileSel: 'profileSel',
};

export const ACCOUNT_TYPES = [CONVERSION.account, CONVERSION.accountSel];

export const PROFILE_TYPES = [CONVERSION.profile, CONVERSION.profileSel];

export const SELECTION_TYPES = [CONVERSION.accountSel, CONVERSION.profileSel];

export const CONVERSION_MODE = {
  skip: 'skip',
  sync: 'sync',
  default: 'default',
};

export const REGEX = {
  otp: /^[0-9]{6}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  spotify: /^https:\/\/(?:open\.)?spotify\.com\/playlist\/([\w\d]+)(?:\?|\/|$)/,
  apple:
    /^https:\/\/(?:www\.)?music\.apple\.com\/[^/]+\/playlist\/(?:[^/]+\/)?(pl\.[\w\d-]+)(?:\?|\/|$)/,
  youtube:
    /^https:\/\/(?:www\.|music\.)?youtube\.com\/(?:playlist\?|watch\?[^#]*[?&])list=([\w-]+)(?:[&#]|$)/,
  profile: {
    spotify:
      /^https:\/\/(?:open\.)?spotify\.com\/(?:user|profile)\/([^\/?#]+)(?:[\/?#]|$)/,
    youtube:
      /^https:\/\/(?:www\.)?youtube\.com\/(?:(channel)\/([^\/?#]+)|(c|user)\/([^\/?#]+)|@([^\/?#]+)|watch\?v=[^&]+&channel=([^&]+))(?:[\/?#]|$)/,
  },
};

export const CURRENT_YEAR = new Date().getFullYear();

export const DEFAULT_TAB = 'single';

export const TABS = ['single', 'account', 'profile'];

export const SLUG_PLATFORM_MAP = {
  'apple-music': 'apple',
  'youtube-music': 'youtube',
};
